import React from 'react';
import { Switch } from 'react-router';
import PrivateRoute from '../../components/PrivateRoute.tsx';
import DisciplineFormPage from './DisciplineFormPage.js';
import ListDisciplinesPage from './ListDisciplinesPage.js';
export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/disciplinas"
      permission="academico.can_view_disciplina"
      component={ListDisciplinesPage}
    />
    <PrivateRoute
      exact
      path="/disciplinas/new"
      permission="academico.can_add_disciplina"
      component={DisciplineFormPage}
    />
    <PrivateRoute
      exact
      path="/disciplinas/:id/edit"
      permission="academico.can_edit_disciplina"
      component={DisciplineFormPage}
    />
  </Switch>
);
